import { render } from "./App.vue?vue&type=template&id=c67b1e2a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c67b1e2a&lang=css"
script.render = render

export default script